import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";

import type { NevoraDataProvider } from "../datos/dataProvider";

/**
 * ¿La base ya tiene el resumen de llamadas (28d)? Sin la 28d la función no existe: el menú no
 * lo enseña. Se pregunta una vez por sesión. undefined mientras se sabe.
 */
export const useResumenDisponible = (): boolean | undefined => {
  const dataProvider = useDataProvider<NevoraDataProvider>();
  const { data } = useQuery({
    queryKey: ["nevora", "resumenDisponible"],
    queryFn: () => dataProvider.resumenDisponible(),
    staleTime: Infinity,
    retry: false,
  });
  return data;
};
